// extracted by mini-css-extract-plugin
export default {"container":"Board_container__JnntB","cardContent":"Board_cardContent__nogA+"};